import React, { useEffect } from 'react'
import {
  Grid, makeStyles, Button, Typography
} from '@material-ui/core'

const version = process.env.REACT_APP_VERSION

const useStyles = makeStyles((theme) => ({
  loginContainer: {
    height: '95vh',
    width: '100vw'
  },
  blueBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    },
    '&:disabled': {
      backgroundColor: 'rgba(57, 132, 247, 0.50)'
    }
  },
  mobileForgotPass: {
    textTransform: 'none',
    color: '#3984f7',
    '&:focus': {
      outline: 'none'
    }
  },
  snackRoot: {
    padding: 'none'
  },
  snackCloseIcon: {
    padding: theme.spacing(0.5),
    color: '#FFFFFF'
  },
  paperRoot: {
    backgroundColor: '#3134384a'
  }
}))

const Login = (props) => {
  const classes = useStyles()

  useEffect(() => {
  }, [])

  const handleSubmit = async (e) => {
    if (e) { e.preventDefault() }
    window.location.href = '/login'
  }


  return (
    <>
      <Grid container direction='row' className={classes.loginContainer} justify='center' alignItems='center'>
        <Grid container item direction='column' xs={6}>
          <Grid container item direction='row' justify='center'>
            <Grid item xs={6} xl={5}>
              <h1>
                <img src={require('../assets/images/logo2.png')} className='logo' alt='LearnSafe Cloud' />
              </h1>
            </Grid>
          </Grid>

          <Grid container item direction='row' justify='center'>
            <Grid item xs={6} xl={5}>
              <h2 className='text-center unselectable'>You have been successfully logged out.</h2>
            </Grid>
          </Grid>

          <Grid container item direction='row' justify='center' className='my-2'>
            <Grid item xs={6} xl={5}>
              <Button
                size='large'
                fullWidth
                type='submit'
                variant='contained'
                className={classes.blueBtn}
                onClick={handleSubmit}
              >
                <Typography variant='h6' style={{ textTransform: 'none' }}>Log In</Typography>
              </Button>
            </Grid>
          </Grid>

        </Grid>
      </Grid>

      <Grid item container direction='row' justify='flex-end'>
        <Typography style={{ marginRight: '2rem' }}>{version}</Typography>
      </Grid>
    </>
  )
}

export default Login
